
















/* General */
import Vue from 'vue'
import CardCanvas from '@/layouts/card-canvas.vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'PeopleCreate',

  metaInfo: {
    title: 'Invite New Users',
  },

  components: {
    CardCanvas,
  },

  data() {
    return {
      RouteAssistant,
    }
  },
})
